


















































































































import HeartFailureIndicator from "@/components/icons/HeartFailureIndicator.vue";
import registerHf from "@/services/registerHf";
import { appModule } from "@/store/modules/app";
import { userModule } from "@/store/modules/user";
import moment from "moment";
import { Component, Prop, Vue } from "vue-property-decorator";
import CardModalAlergi from "@/components/modal/CardModalAlergi.vue";
import DataPasien from "@/services/DataPasien";
import PasienCustomWarningIndicator from "@/components/icons/PasienCustomWarningIndicator.vue";
import { storePasien } from "@/store/modules/pasien";
import PasienTag from "@/services/new/PasienTag";
import ListPasien from "@/services/ListPasien";
import ListPasienRalan from "@/store/modules/new/ListPasienRalan";
import { toggleHeartFailureIndicator } from "@/utility/PasienTagHelper";
import PasienContextMenuButton from "@/components/icons/PasienContextMenuButton.vue";
import axios from "axios";
import CardModalDetailPasien from "@/components/modal/CardModalDetailPasien.vue";

const API_THIWUL = process.env.VUE_APP_API_THIWUL;

interface InDigiclaim {
  status: string;
  data: [
    {
      id: number;
      nama: string;
      ket: 0 | 1;
      link: string;
      trans: {
        tgl: string;
        no_trans: string[];
      };
    }
  ];
  identitas: {
    cm: number;
    nama: string;
    alamat: string;
    register: number;
    tanggal: string;
    tanggal_pulang: string;
    asrn: string;
    unit: string;
  };
  link: string;
}

@Component({
  components: {
    CardModalAlergi,
    HeartFailureIndicator,
    PasienCustomWarningIndicator,
    PasienContextMenuButton,
    CardModalDetailPasien
  }
})
export default class DataSosialPasienCard extends Vue {
  @Prop() readonly dt: any;
  @Prop() readonly cm: string;
  @Prop() hidden: string;
  @Prop() readonly loading!: boolean;
  getAlergi = "";
  alergi = "";
  modalOpen = false;
  hiddenBtn = false;
  hiddenAlergi = false;
  reload = {};
  isModalPasienOpen = false;

  showModalPasien() {
    this.isModalPasienOpen = true;
  }

  closeModalPasien() {
    this.isModalPasienOpen = false;
  }

  get statePasien() {
    return storePasien.identitasPasien;
  }

  // get hasSkriningBatuk() {
  //   return storePasien.hasSkriningBatuk;
  // }

  get hasRegHFTag() {
    return storePasien.isTagRegHF;
  }

  toggleRegHF() {
    toggleHeartFailureIndicator(
      async () => {
        await storePasien.getPasienTag();
        await ListPasienRalan.getListWithoutParam();

        const qExam = confirm(
          "Berhasil menandai pasien. Lanjut mencatat pemeriksaan?"
        );

        if (qExam) {
          this.$emit("addSoap", {
            rm: storePasien.identitasPasien.rm,
            register: storePasien.registerPasien.register_id,
            page: "tab-soap"
          });
        }
      },
      () => {
        storePasien.getPasienTag();
        ListPasienRalan.getListWithoutParam();
      }
    );
  }

  get showHFIndicator() {
    return this.cm !== "";
  }

  addAlergi(value) {
    appModule.setLoading(true);

    const dt = DataPasien.updateAlergiPasien(this.cm, value);
    dt.then(dt => {
      appModule.setLoading(false);
      if (dt["status"] != 1) {
        // appModule.sendErrorAlert(dt["err"]);
      } else {
        this.reload = {
          item: {
            register_id: this.dt["register"],
            rm: this.cm
          }
        };
        this.$emit("reloadAlergi", this.reload);
      }
    });
  }

  cekAlergi(value) {
    if (this.hidden == "") {
      this.hiddenBtn = false;
      this.hiddenAlergi = false;
    } else {
      if (value == "" || value == null) {
        this.hiddenBtn = true;
        this.hiddenAlergi = false;
        this.getAlergi = value;
      } else {
        this.hiddenBtn = false;
        this.hiddenAlergi = true;
        this.getAlergi = value;
      }
    }
  }

  kelamin(jk) {
    if (jk == "P") return " : Perempuan";
    else if (jk == "L") return " : Laki-laki";
    else return "";
  }

  usia(value) {
    if (value["th"] == "") {
      return "";
    } else {
      return (
        ": " +
        value["th"] +
        " Th " +
        value["bln"] +
        " Bln " +
        value["hr"] +
        " Hr"
      );
    }
  }

  modalAlergi(value) {
    this.alergi = value;
    this.modalOpen = true;
  }
  getHumanDate(date) {
    return date
      ? moment(date, "DD-MM-YYYY").format("DD MMMM YYYY")
      : "--- : --- : ---";
  }

  get showRegisterHF() {
    return userModule.user.unit_group_id == "27";
  }

  loadingSEPFile = false;

  async previewSep(noReg) {
    this.loadingSEPFile = true;
    const listBerkas: InDigiclaim = await axios
      .get(`${API_THIWUL}/list-berkas/reg/${noReg}`)
      .then(dt => dt.data);

    const sep = listBerkas.data.find(item => item.id == 1101 && item.ket == 1);

    this.loadingSEPFile = false;

    if (sep?.link.length > 0) {
      window.open(sep.link[0], "__blank");
    } else {
      appModule.sendErrorAlert(
        "Berkas SEP Ralan tidak tersedia atau belum diunggah. Silahkan hubungi TPP/ Admisi..."
      );
    }
  }
}
